import { ReactNode } from 'react';

import styles from './Cell.module.scss';
import { FormattedMessage } from 'react-intl';

type EmptyProps = {
  children?: ReactNode;
};

const EmptyCell = ({ children }: EmptyProps) => {
  return (
    <div className={`${styles.empty} ${styles.ellipsis}`}>
      {children ?? <FormattedMessage id="NO_CONTENT" />}
    </div>
  );
};

export default EmptyCell;
